<template>
  <div class="modal-overlay">
    <dialog class="card modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Сохранить фильтр</h3>
        <button class="close-btn" @click="$emit('close')">✕</button>
      </div>

      <form @submit.prevent="handleSubmit" class="modal-form">
        <div class="form-body">
          <div class="form-group">
            <base-label>Название фильтра</base-label>
            <base-input
              v-model="filterName"
              :class="{ invalid: nameError }"
              placeholder="Например: Активные заказы"
              @input="nameError = false"
            />
            <span class="error-message" v-if="nameError">
              Введите название фильтра
            </span>
          </div>
        </div>

        <div class="form-actions sticky-footer">
          <base-primary-button type="submit" :disabled="isSubmitting">
            <span v-if="isSubmitting">Сохранение...</span>
            <span v-else>Сохранить</span>
          </base-primary-button>

          <base-button
            type="button"
            @click="$emit('close')"
            :disabled="isSubmitting"
          >
            Отмена
          </base-button>
        </div>
      </form>
    </dialog>
  </div>
</template>

<script>
export default {
  name: "SaveFilterModal",
  emits: ["close", "save"],
  data() {
    return {
      filterName: "",
      nameError: false,
      isSubmitting: false,
    };
  },
  methods: {
    handleSubmit() {
      if (!this.filterName.trim()) {
        this.nameError = true;
        return;
      }

      this.isSubmitting = true;
      this.$emit("save", this.filterName.trim());
    },
  },
};
</script>

<style scoped>
.modal-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid var(--color-grey);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  flex-shrink: 0;
}

.modal-title {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  color: var(--color-dark);
  background: #f5f5f5;
}

.modal-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.form-body {
  flex: 1;
  padding: 20px;
}

.error-message {
  font-size: 12px;
  color: var(--color-danger);
  margin-top: 4px;
}

.sticky-footer {
  padding: 20px;
  border-top: 1px solid var(--color-grey);
  background: #fff;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 767px) {
  .sticky-footer {
    gap: 10px;
  }

  .sticky-footer button {
    flex: 1;
  }
}
</style>
